module.exports = __webpack_public_path__ + "8e714777f23624c6f503aaf18e4928a3.svg";